import { z } from 'zod';

// Preparation error details - exported for reuse
export const PreparationErrorDetailsSchema = z.object({
  type: z.literal('missing_field'),
  field: z.union([z.enum(['phone', 'name', 'contact', 'events']), z.string()])
});

export const operationSchema = z.enum(['register', 'update', 'unregister']);

// Discriminated union for vendor results - EXACT match of backend payload
export const VendorResultSchema = z.discriminatedUnion('status', [
  // Success
  z.object({
    vendor: z.string(),
    operation: operationSchema.nullable(),
    status: z.literal('success'),
    message: z.null(),
    // Optional reason for unregister operations (explains why it was unregistered)
    reason: z
      .discriminatedUnion('status', [
        // Not eligible (booking no longer qualifies)
        z.object({
          status: z.literal('not_eligible'),
          reason: z.string(),
          message: z.string()
        }),
        // Preparation error (missing required field)
        z.object({
          status: z.literal('preparation_error'),
          message: z.string(),
          preparation_error_details: PreparationErrorDetailsSchema.optional()
        })
      ])
      .optional()
  }),
  // Preparation error (missing required data - user can fix)
  z.object({
    vendor: z.string(),
    operation: operationSchema.nullable(),
    status: z.literal('preparation_error'),
    message: z.string().nullable(),
    preparation_error_details: PreparationErrorDetailsSchema.optional()
  }),
  // API error (vendor communication failed)
  z.object({
    vendor: z.string(),
    operation: operationSchema.nullable(),
    status: z.literal('api_error'),
    message: z.string().nullable()
  }),
  // Not eligible (wrong type/status - user typically can't fix)
  z.object({
    vendor: z.string(),
    operation: operationSchema.nullable(),
    status: z.literal('not_eligible'),
    message: z.string().nullable()
  })
]);

export const VisitorManagementProcessedEventSchema = z.object({
  bookingId: z.int(),
  bookingOwnerId: z.string().nullable(),
  triggeredByAccountId: z.string().nullable(),
  vendors: z.array(VendorResultSchema)
});

// Inferred types with discriminated unions
export type PreparationErrorDetails = z.infer<
  typeof PreparationErrorDetailsSchema
>;
export type VendorResult = z.infer<typeof VendorResultSchema>;
export type VisitorManagementProcessedEvent = z.infer<
  typeof VisitorManagementProcessedEventSchema
>;
